<template>
	<v-card>
		<v-card-title>Query Panel Members</v-card-title>
		<v-card-text>
			<v-row v-for="(query, index) in queries" v-bind:key="index">
				<v-col cols="12" md="4">
					<v-btn absolute left icon x-small @click="deleteCondition(index)"><v-icon>mdi-close</v-icon></v-btn>
					<v-select class="pl-5 ml-5" label="Question" :items="savedQuestions" item-text="title" return-object v-model="query.question"></v-select>
				</v-col>
				<v-col cols="12" md="3" v-if="query.question.type == 'matrix'">
					<v-select  label="Subquestion" :items="query.question.rows" item-text="text" item-value="value" v-model="query.subquestion"></v-select>
				</v-col>
				<v-col cols="12" md="1" v-if="query.question">
					<v-select  label="Operator" :items="['==', '>', '>=', '<', '<=', 'in', 'array-contains' ]" v-model="query.operator"></v-select>
				</v-col>
				<v-col cols="12" md="3" v-if="query.question">
					<v-select label="Answer Option"  v-if='query.question.options' :items="query.question.options" v-model="query.value"></v-select>
					<v-select label="Answer Option" v-if='query.question.columns' :items="query.question.columns" v-model="query.value"></v-select>
					<v-text-field label="Free Text" v-if='!query.question.options && !query.question.columns' v-model="query.value"></v-text-field>
				</v-col>
			</v-row>
			<p class="text-right">
				<v-btn dark color="green" small @click="insertQuery">Add Condition</v-btn>
			</p>
		</v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
			<p class="overline ma-4">Count: {{results.length}} </p>
			<v-spacer></v-spacer>
			<v-btn color="primary" text @click="doQuery">Run Query</v-btn>
			<v-btn color="primary" text @click="$emit('complete', results)">Apply Filter</v-btn>
        </v-card-actions>
	</v-card>

</template>
<script>
	import Vuex from 'vuex';
	export default{
		name: "Querypanelists",
		props: {
		},
		data: () => ({
			queries: [],
			results: []
		}),
		computed: {
			...Vuex.mapState({
				savedQuestions: state => state.admin.savedQuestions,
			}), 
		},
		methods: {
			insertQuery(){
				this.queries.push({question: false, subquestion: false, operator: false, value: '' })
			},
			insert(content){
				this.conditions.splice( this.position+1, 0, content )
				this.position++;
			},
			doQuery(){
				const self = this;
				let conditions = self.queries.map( query => {
					if( !query.question || !query.operator || query.value == '' ){
						self.error = true;
						return false;
					}
					let condition = {value: query.value, operator: query.operator }
					condition.question = query.question.name;
					if( query.subquestion ){
						condition.question += ".";
						condition.question += query.subquestion;
					}
					return condition;
				})

				self.$store.dispatch("queryPanelMembers", conditions ).then( (response) => {
					self.results = response;
				});
			},
			deleteCondition(index){
				this.queries.splice(index)
			}
		},
		created(){
			this.$store.dispatch("fetchSurveyQuestionLibrary" )
		}
	}
</script>